import { Injectable, inject } from '@angular/core';

import { OnAppInit } from '@frontend/vanilla/core';

import { TagManagerRenderer } from '../../shared/services/tagmanager-renderer.service';

@Injectable()
export class GTMBootstrapService implements OnAppInit {
    private readonly tagManagerRenderer = inject(TagManagerRenderer);

    onAppInit() {
        this.tagManagerRenderer.renderGTMTag();
    }
}
